import './BillingModalHeader.pcss';
import React from 'react';
import classnames from 'classnames';
import {
  EnhancedPlan,
  PlanSubtypes,
  PlanTypeBE,
} from '@mm/state/interfaces/subscription';
import {
  EnhancedBillingPage,
  PageBillingType,
} from '@mm/state/interfaces/connected-page';
import CompanyModel from '@mm/state/model/CompanyModel';
import { ReactComponent as IndividualPlanBadge } from '../../../../../../../www/assets/billing-badges-new/individualPlanBadge.svg';
import { ReactComponent as StartupPlanBadge } from '../../../../../../../www/assets/billing-badges-new/startupPlanBadge.svg';
import { ReactComponent as AgencyPlanBadge } from '../../../../../../../www/assets/billing-badges-new/agencyPlanBadge.svg';
import { ReactComponent as GrowthPlanBadge } from '../../../../../../../www/assets/billing-badges-new/growthPlanBadge.svg';

type Props = {
  facebookPage?: EnhancedBillingPage;
  plan: EnhancedPlan;
  company?: CompanyModel;
};

const BillingModalHeader = ({ facebookPage, plan, company }: Props) => {
  const classList = classnames('billing-modal-header', {
    'billing-modal-header--team-plan': [
      PageBillingType.Team,
      PageBillingType.NewTeam,
      PageBillingType.CustomTeam,
    ].includes(plan.pageBillingType),
    'billing-modal-header--pro-unicorn-plan':
      plan.pageBillingType === PageBillingType.ProUnicorn,
  });

  const badge =
    plan.planType === PlanTypeBE.team ? (
      plan.planSubtypes.includes(PlanSubtypes.teamCustom) ? (
        <GrowthPlanBadge />
      ) : (
        <AgencyPlanBadge />
      )
    ) : plan.planType === PlanTypeBE.pro &&
      plan.planSubtypes.includes(PlanSubtypes.unicorn) ? (
      <StartupPlanBadge />
    ) : (
      <IndividualPlanBadge />
    );

  return (
    <div className={classList}>
      {plan.planType === PlanTypeBE.team && company && (
        <div className="billing-modal-header__company-name">
          Company: <strong>{company.name}</strong>
        </div>
      )}
      {plan.planType !== PlanTypeBE.team && (
        <div className="billing-modal-header__facebook-page-name">
          {facebookPage?.name}
        </div>
      )}
      <div className="billing-modal-header__plan-badge">{badge}</div>
    </div>
  );
};

export { BillingModalHeader };
